import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges, OnChanges } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalFormRealizarConsultaComponent } from '../modal-form-realizar-consulta/modal-form-realizar-consulta.component';
import { UtilValidators } from 'src/app/utils/util-validators';
import { UtilMasks } from 'src/app/utils/util-masks';
import { UtilForms } from 'src/app/utils/util-forms';

@Component({
  selector: 'app-form-realizar-consulta',
  templateUrl: './form-realizar-consulta.component.html',
  styleUrls: ['./form-realizar-consulta.component.scss']
})
export class FormRealizarConsultaComponent implements OnInit, OnChanges {

  @Input() formView = {
    veiculo: false,
    tipoPesquisaVeiculo: 'placa',
    tipoPesquisaCnh: 'cnh',
    documento: false,
    renavam: false,
    placaRenavam: false,
    cnh: false,
    crlv: false,
    cpf: false,
    cnpj: false,
    uf: false,
    placa: false,
  };


  @Input() totalConsultas = '';

  @Input() consultasCreditoSelecionadas;

  @Output() formViewChanges = new EventEmitter();

  @Output() submit = new EventEmitter();

  controlVeiculoPlaca = new FormControl('', [Validators.required, Validators.minLength(7)]);
  controlVeiculoChassi = new FormControl('', [Validators.required, Validators.maxLength(17)]);
  controlVeiculoMotor = new FormControl('', [Validators.required, Validators.maxLength(30)]);
  controlDocumento = new FormControl('', [Validators.required, UtilValidators.documento]);
  controlCrlv = new FormControl('', [Validators.required, Validators.minLength(9), Validators.maxLength(30)]);
  controlCpf = new FormControl('', [UtilValidators.cpf, Validators.required]);
  controlCnpj = new FormControl('', [UtilValidators.cnpj, Validators.required]);
  controlRenavam = new FormControl('', [Validators.maxLength(11), Validators.required]);
  controlUf = new FormControl('');
  controlUfObrigatorio = new FormControl('', [Validators.required]);
  controlCnh = new FormControl('', [Validators.required, Validators.minLength(11), Validators.maxLength(14)]);
  controlCnh_Cpf = new FormControl('', [UtilValidators.cpf, Validators.required]);

  form: FormGroup;
  ufOptions = [{ label: 'Selecione', value: '' }, ...UtilForms.optionsEstado.nome];
  masks = {
    documento: { mask: UtilMasks.documento, guide: false },
    placa: { mask: UtilMasks.placa, guide: false },
    cpf: { mask: UtilMasks.cpf, guide: false },
    renavam: { mask: UtilMasks.renavam, guide: false },
    cnpj: { mask: UtilMasks.cnpj, guide: false }
  };

  disabledVeiculoOptions = {
    placa: false,
    motor: false,
    chassi: false,
  }

  cpf: boolean = false;
  cnpj: boolean = false;
  uf: boolean = false;

  @Input() ufOpcional: boolean = false;
  @Input() ufObrigatorio: boolean = false;

  constructor(private modalService: NgbModal) { }

  ngOnInit() {
    this.setFormGroup();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.setFormGroup();
  }

  eventoClick(value) {
    this.formView.tipoPesquisaVeiculo = value;
    this.setFormGroup();
  }

  setControlVeiculo() {

    if(this.formView.placa) {
      this.form.setControl('veiculo',this.controlVeiculoPlaca);
      this.disabledVeiculoOptions = {placa: false, chassi: true, motor: true};
      this.formView.tipoPesquisaVeiculo = 'placa';
      return;
    }

    if (this.formView.veiculo) {
      this.disabledVeiculoOptions = {placa: false, chassi: false, motor: false};
      this.form.setControl('veiculo',
        this.formView.tipoPesquisaVeiculo === 'motor' ? this.controlVeiculoMotor :
          this.formView.tipoPesquisaVeiculo === 'chassi' ? this.controlVeiculoChassi :
            this.controlVeiculoPlaca
      );
    }
  }

  setControlCnh() {
    if (this.formView.cnh) {

      if(this.formView.tipoPesquisaCnh == 'cnh') {
        this.form.addControl('cnh', this.controlCnh);
        this.form.removeControl('cnh_cpf');
      }
      if(this.formView.tipoPesquisaCnh == 'cpf') {
        this.form.removeControl('cnh');
        this.form.addControl('cnh_cpf', this.controlCnh_Cpf);
      }
    }
    return this.formView.tipoPesquisaCnh;
  }

  setFormGroup() {
    this.form = new FormGroup({});

    if (this.formView.crlv) {
      this.form.addControl('crlv', this.controlCrlv);
    }

    if (this.formView.documento) {
      this.form.addControl('documento', this.controlDocumento);
    }

    if (this.formView.cnpj) {
      this.form.addControl('cnpj', this.controlCnpj);
    }

    if (this.formView.renavam) {
      this.form.addControl('renavam', this.controlRenavam);
    }

    if (this.formView.placaRenavam) {
      this.form.addControl('renavam', this.controlRenavam);
    }

    if (this.formView.cpf && !this.form.controls.cpf) {
      this.form.addControl('cpf', this.controlCpf);
    }

    if (this.formView.uf) {
      this.form.addControl('uf', this.controlUf);
    }

    if (this.ufOpcional) {
      this.form.addControl('uf', this.controlUf);
    }

    if (this.ufObrigatorio) {
      this.form.addControl('uf', this.controlUfObrigatorio);
    }

    this.setControlVeiculo();

    this.setControlCnh();
    

  }

  openModal() {
    const modalRef = this.modalService.open(ModalFormRealizarConsultaComponent, { centered: true });
    modalRef.componentInstance.formValues = this.form.value;
    modalRef.componentInstance.tipoPesquisaVeiculo = this.formView.tipoPesquisaVeiculo;
    modalRef.result.then(result => {
      if (result === 'ok') {
        this.submit.emit({
          placa: this.formView.tipoPesquisaVeiculo === 'placa' ? this.controlVeiculoPlaca.value : '',
          chassi: this.formView.tipoPesquisaVeiculo === 'chassi' ? this.controlVeiculoChassi.value : '',
          motor: this.formView.tipoPesquisaVeiculo === 'motor' ? this.controlVeiculoMotor.value : '',
          crlv: this.formView.crlv ? this.controlCrlv.value : '',
          documento: (this.formView.tipoPesquisaCnh == 'cpf' ? this.controlCnh_Cpf.value : '') || (this.formView.documento ? this.controlDocumento.value : ''),
          cnh: this.formView.cnh && this.formView.tipoPesquisaCnh != 'cpf' ? this.controlCnh.value : '',
          cpf: this.form.controls.cpf ? this.form.controls.cpf.value : '',
          cnpj: this.form.controls.cnpj ? this.form.controls.cnpj.value : '',
          renavam: this.form.controls.renavam ? this.form.controls.renavam.value : '',
          uf: this.form.controls.uf ? this.form.controls.uf.value : '',
        });
      }
    }).catch(error => console.error(error));
  }

  formSubmit() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }
    this.openModal();
  }

}
